<template>
  <layout-default>
    <div class="policy-page container">
      <header class="policy-header">
        <h1>Return Policy</h1>
        <p>
          Review the guidelines below to understand how returns, cancellations, and refunds are handled across the
          Viabrera marketplace.
        </p>
      </header>

      <section class="policy-section">
        <h2>Eligibility Window</h2>
        <p>
          Most items can be returned within 14 days of delivery as long as they remain unused, include original
          packaging, and contain all documentation. Custom or perishable goods may not qualify for return.
        </p>
      </section>

      <section class="policy-section">
        <h2>How to Start a Return</h2>
        <p>
          Contact our support team with your order number and reason for return. We will send detailed instructions
          and a shipping label when applicable. Items must be shipped back within 7 days after the authorization is
          issued.
        </p>
      </section>

      <section class="policy-section">
        <h2>Refunds</h2>
        <p>
          Refunds are issued to the original payment method after the item is received and inspected. Shipping
          charges are refundable when the return is due to an error on our part. Please allow 5 to 7 business days
          for the refund to appear on your statement.
        </p>
      </section>
    </div>
  </layout-default>
</template>

<script>
import LayoutDefault from "../../components/organisms/LayoutDefault/LayoutDefault.vue";

export default {
  name: "ReturnPolicy",
  components: { LayoutDefault },
  created() {
    document.title = "Return Policy - viabrera";
  },
};
</script>

<style scoped>
.policy-page {
  padding: 60px 0 120px;
  color: #1f1f1f;
}

.policy-header {
  margin-bottom: 40px;
  text-align: left;
}

.policy-header h1 {
  font-size: clamp(2rem, 4vw, 2.8rem);
  margin-bottom: 12px;
}

.policy-header p {
  max-width: 720px;
  margin: 0;
  color: #5b5b5b;
  line-height: 1.6;
}

.policy-section + .policy-section {
  margin-top: 32px;
}

.policy-section h2 {
  font-size: 1.5rem;
  margin-bottom: 12px;
}

.policy-section p {
  margin: 0;
  line-height: 1.7;
  color: #3c3c3c;
}
</style>
